import React from 'react';
import ScrollAnimation from "react-animate-on-scroll";
import {Link} from "react-router-dom";
import { FiArrowRight, FiCheck } from "react-icons/fi";

const AboutTwo = () => {
    return (
        <div className="rwt-about-area about-style-2 rn-section-gap">
            <div className="container">
                <div className="row row--30 align-items-center">
                    <div className="col-lg-5">
                        <div className="thumbnail">
                            <img className="w-100" src="./images/about/Aboutourservices-low.png" alt="About Images" />
                        </div>
                    </div>

                    <div className="col-lg-7 mt_md--30 mt_sm--30">
                        <div className="content">
                            <div className="section-title">

                                <ScrollAnimation 
                                animateIn="fadeInUp"
                                animateOut="fadeInOut"
                                animateOnce={true}>
                                    <h4 className="subtitle"><span className="theme-gradient">Who we are</span></h4>
                                    <h2 className="title mt--10">About Us</h2>
                                </ScrollAnimation>

                                <ScrollAnimation 
                                animateIn="fadeInUp"
                                animateOut="fadeInOut"
                                animateOnce={true}>
                                    <p>We are a global collective of people who love to make videos stand out! Our team consists of self-driven and creative people. 
                                    As a team, we care while finding comfort and enjoyment in working together. We want to make video editing simple and affordable for businesses and creators around the world.
                                    <br/>Our core values are:</p>

                                    <ul className="list-icon">
                                        <li><span className="icon"><FiCheck /></span> Customer Satisfaction</li>
                                        <li><span className="icon"><FiCheck /></span> Reliability</li>
                                        <li><span className="icon"><FiCheck /></span> Transperency</li>
                                        <li><span className="icon"><FiCheck /></span> Positivity</li>
                                    </ul>
                                </ScrollAnimation>
                            </div>
                        </div>
                    </div>
                </div>
            </div>   
        </div>
    )
}

export default AboutTwo;
